/**
 * @fileoverview Types for USA Supply integration
 */

import * as yup from 'yup'
import { WriteIntegrationEntityType, WriteIntegrationMode } from '../action-step-selections.js'

// Hardcoded credentials username for Doss integration credentials
export const USA_SUPPLY_API_USER = 'Doss'

/**
 * USA Supply Write Record Action Step Input Schema
 */
export const usaSupplyWriteRecordActionStepInputSchema = yup.object({
  mode: yup
    .string()
    .oneOf([WriteIntegrationMode.CREATE, WriteIntegrationMode.UPDATE] as const)
    .required(),
  entity: yup
    .string()
    .oneOf([
      WriteIntegrationEntityType.ACH,
      WriteIntegrationEntityType.ANNOUNCEMENT,
      WriteIntegrationEntityType.BUYER,
      WriteIntegrationEntityType.COMMITMENT,
      WriteIntegrationEntityType.DEAL,
      WriteIntegrationEntityType.PAYMENT_REQUEST,
      WriteIntegrationEntityType.TRACKING_NUMBER,
      WriteIntegrationEntityType.PURCHASE_ORDER,
      WriteIntegrationEntityType.CHECK_PAYEE_NAME,
    ] as const)
    .required(),
  data: yup.object().required(),
})

export type USASupplyWriteRecordActionStepInput = yup.InferType<
  typeof usaSupplyWriteRecordActionStepInputSchema
>

/**
 * USA Supply Write Record Action Step Input Schema
 */
export const usaSupplyDeleteRecordActionStepInputSchema = yup.object({
  entity: yup
    .string()
    .oneOf([
      WriteIntegrationEntityType.ANNOUNCEMENT,
      WriteIntegrationEntityType.COMMITMENT,
      WriteIntegrationEntityType.DEAL,
      WriteIntegrationEntityType.TRACKING_NUMBER,
      WriteIntegrationEntityType.PURCHASE_ORDER,
    ] as const)
    .required(),
  data: yup.object().required(),
})

export type USASupplyDeleteRecordActionStepInput = yup.InferType<
  typeof usaSupplyDeleteRecordActionStepInputSchema
>
